import styled from "styled-components"
import Input from "../../components/Input";
import Button from "../../components/Button";
import { SwiperSlide } from "swiper/react";

export const Header = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 25px 150px;
  text-align: center;

  @media (max-width: 768px) {
    padding: 20px;
  }

  h2 {
    font-size: 1.8rem;

    @media (max-width: 768px) {
      font-size: 1.2rem;
    }
  }
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 50px;

  @media (max-width: 768px) {
    padding: 0 50px;
  }
`;

export const SearchSection = styled.section`
  margin-top: 40px;
  padding: 0 20px;
`;

export const Title = styled.h3`
  margin-bottom: 20px;
  font-size: 1.8rem;
  color: var(--secondary);
  padding: 0 50px;
`;

export const CustomInput = styled(Input)`
  flex: 1;
  min-width: 0;
  padding: 10px;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

export const CustomButton = styled(Button)`
  flex: none;
  padding: 10px 20px;
  background-color: var(--gold);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  padding: 0 50px;
  flex-wrap: wrap;
`;


export const SearchBar = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
  margin-bottom: 30px;
  padding: 0 50px;

  & > * {
    flex-shrink: 0;
  }
`;

export const GridWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  padding: 0 50px;
`;

export const Slide = styled(SwiperSlide)`
  min-width: 300px;
`;

